<app-attributes-filter 
    [AttributeModal]="filterService.selectedAttribute" 
    (AttributeSelected)="SetAttribute($event)" 
    (AttributeModalChanged)="SetAttributeModal($event)"></app-attributes-filter>
